<script setup lang="ts">

</script>

<template>
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.5002 11.175L1.5002 11.175C1.0502 11.175 0.637695 11.55 0.637695 12.0375C0.637695 12.4875 1.0127 12.9 1.5002 12.9L22.5002 12.9C22.9502 12.9 23.3627 12.525 23.3627 12.0375C23.3627 11.55 22.9502 11.175 22.5002 11.175Z"
        />
        <path
            d="M22.5002 17.55L1.5002 17.55C1.0502 17.55 0.637695 17.925 0.637695 18.4125C0.637695 18.9 1.0127 19.275 1.5002 19.275L22.5002 19.275C22.9502 19.275 23.3627 18.9 23.3627 18.4125C23.3627 17.925 22.9502 17.55 22.5002 17.55Z"
        />
        <path
            d="M1.5002 6.45001L22.5002 6.45001C22.9502 6.45001 23.3627 6.07501 23.3627 5.58751C23.3627 5.10001 22.9877 4.72501 22.5002 4.72501L1.5002 4.72501C1.0502 4.72501 0.637695 5.10001 0.637695 5.58751C0.637695 6.07501 1.0502 6.45001 1.5002 6.45001Z"
        />
    </svg>
</template>

<style scoped>

</style>
